import React from "react";
import { Form, Switch } from "antd";
const { Item } = Form;

const InputSwitch = (props) => {
  const { id, name, label, required, value, onChangeHandler } = props;

  return (
    <div>
      <Item
        key={id}
        name={name}
        label={label}
        size="true"
        rules={[
          {
            required: required,
          },
        ]}
      >
        <Switch defaultChecked={value} onChange={onChangeHandler} />
      </Item>
    </div>
  );
};

export default InputSwitch;
